<template>
  <div class="newsletter__subscribe newsletter__subscribe_error">
    <header class="newsletter__header">{{ message }}</header>
    <close-button :on-close-callback="onClose" class="newsletter__btn_error">Luk</close-button>
  </div>
</template>

<script>
import CloseButton from '../components/CloseButton.vue'

export default {
  name: 'ResponseErrorView',
  components: [CloseButton],
  data() {
    return {
      message: this.$root.config.response.error,
      onClose: this.$root.config.callback.onClose
    }
  }
}
</script>


// WEBPACK FOOTER //
// ResponseErrorView.vue?16fb5ced